/* FMS popup accessibility adapter. Opt-in only; no pricing, cart, or copy changes. */
(function (factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else factory(document, window);
})(function (doc, view) {
  'use strict';
  var marker = doc.querySelector('[data-fms-popup-a11y]');
  if (!marker || doc.documentElement.hasAttribute('data-fms-popup-a11y-bound')) return null;
  doc.documentElement.setAttribute('data-fms-popup-a11y-bound', '');

  var states = [], active = null, queued = null, restoreTimer = null;
  var redirecting = false, stopped = false;
  var tabSelector = 'a[href],area[href],button,input,select,textarea,iframe,' +
    '[tabindex],[contenteditable="true"],summary';
  var listenerRecords = [];
  var ownerSelector = 'cart-drawer.active,[role="dialog"][aria-modal="true"],[role="alertdialog"][aria-modal="true"],dialog[open]';

  function listen(type, fn) {
    doc.addEventListener(type, fn, true);
    listenerRecords.push([type, fn]);
  }
  function all(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function set(node, name, value) {
    if (node && node.getAttribute(name) !== value) node.setAttribute(name, value);
  }
  function visible(node) {
    if (!node || !node.isConnected) return false;
    for (var n = node; n && n.nodeType === 1; n = n.parentElement) {
      if (n.hidden || n.hasAttribute('inert') || n.getAttribute('aria-hidden') === 'true') return false;
      // Chromium can report a nonzero rect for a dialog inside closed DETAILS.
      // Native disclosure semantics expose only the first direct SUMMARY and
      // its descendants, regardless of those descendants' computed display.
      if (n.tagName === 'DETAILS' && !n.hasAttribute('open') && n !== node) {
        var summary = Array.prototype.slice.call(n.children).filter(function (child) { return child.tagName === 'SUMMARY'; })[0];
        if (!summary || !summary.contains(node)) return false;
      }
      var style = view.getComputedStyle(n);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    }
    return node.getClientRects().length > 0;
  }
  function enabled(node) {
    return visible(node) && !node.disabled && !node.matches(':disabled') && node.getAttribute('aria-disabled') !== 'true';
  }
  function focus(node, preventScroll) {
    if (!enabled(node)) return false;
    // Native scrolling keeps wrapped Tab targets and stage headings visible on
    // narrow phones. Only returning to the page opener preserves page scroll.
    try { node.focus({ preventScroll: !!preventScroll }); } catch (_) { node.focus(); }
    return doc.activeElement === node;
  }
  function cancelRestore() {
    if (restoreTimer !== null) view.clearTimeout(restoreTimer);
    restoreTimer = null;
  }
  function stateFor(kind) { return states.filter(function (s) { return s.kind === kind && s.root.isConnected; })[0]; }
  function qfp(state, name) { return state.root.querySelector('[data-qfp-cc="' + name + '"]'); }
  function isOpen(state) {
    return state.root.classList.contains(state.kind === 'print' ? 'fmscp-on' : 'qfp-cc-on') && visible(state.root);
  }
  function current() {
    var found = states.filter(isOpen).sort(function (a, b) {
      return (parseInt(view.getComputedStyle(b.root).zIndex, 10) || 0) - (parseInt(view.getComputedStyle(a.root).zIndex, 10) || 0);
    })[0] || null;
    if (found && externalOwners(found).some(function (node) { return layer(node) > layer(found.root); })) return null;
    return found;
  }
  function layer(node) {
    var z = 0;
    for (var n = node; n && n.nodeType === 1; n = n.parentElement) z = Math.max(z, parseInt(view.getComputedStyle(n).zIndex, 10) || 0);
    return z;
  }
  function externalOwners(state) {
    return all(doc, ownerSelector).filter(function (node) {
      return node !== state.root && !state.root.contains(node) && !node.contains(state.root) && visible(node);
    });
  }
  function stage(state) {
    if (state.kind === 'print') return state.root;
    return ['success', 'approval', 'body', 'spinner'].map(function (name) { return qfp(state, name); }).filter(visible)[0] || state.root;
  }
  function initialFocus(state) {
    var panel = stage(state);
    var heading = panel.querySelector(state.kind === 'print' ? '.fmscp-title' : '.qfp-cc-title');
    if (heading && visible(heading)) { set(heading, 'tabindex', '-1'); return heading; }
    return state.root.querySelector(state.kind === 'print' ? '#fmscp-close' : '[data-qfp-cc="close"]');
  }
  function recoveredFocus(state) {
    var previous = state.lastInside, parent = previous && previous.parentElement;
    // At a yardage boundary the focused +/- button becomes disabled. Keep the
    // shopper in that control when its single sibling numeric input is usable;
    // do not guess among multiple inputs or reach outside this popup.
    if (previous && previous.tagName === 'BUTTON' && parent && state.root.contains(parent)) {
      var inputs = Array.prototype.slice.call(parent.children).filter(function (node) {
        return node.tagName === 'INPUT' && node.type === 'number' && node.tabIndex >= 0 && enabled(node);
      });
      if (inputs.length === 1) return inputs[0];
    }
    return initialFocus(state);
  }
  function tabbables(state) {
    var nodes = all(state.root, tabSelector).filter(function (node) {
      if (!enabled(node) || node.tabIndex < 0 || node.type === 'hidden') return false;
      // Native radio groups contribute just their checked radio (or first enabled radio).
      if (node.type === 'radio' && node.name) {
        var group = all(state.root, 'input[type="radio"]').filter(function (other) {
          return other.name === node.name && other.form === node.form && enabled(other) && other.tabIndex >= 0;
        });
        return node === (group.filter(function (other) { return other.checked; })[0] || group[0]);
      }
      return true;
    });
    // Respect positive tabindex if a future native control supplies one.
    return nodes.map(function (node, i) { return { node: node, i: i }; }).sort(function (a, b) {
      var x = a.node.tabIndex > 0 ? a.node.tabIndex : Infinity;
      var y = b.node.tabIndex > 0 ? b.node.tabIndex : Infinity;
      return x === y ? a.i - b.i : x - y;
    }).map(function (entry) { return entry.node; });
  }
  function anotherOwner(state) {
    return externalOwners(state).length > 0;
  }
  function restore(state) {
    cancelRestore();
    // The existing add path closes its popup BEFORE opening the drawer. Let that
    // asynchronous owner settle; never return focus over a drawer or user action.
    restoreTimer = view.setTimeout(function () {
      restoreTimer = null;
      if (stopped || current() || anotherOwner(state)) return;
      var focused = doc.activeElement;
      if (focused && focused !== doc.body && focused !== doc.documentElement &&
          !state.root.contains(focused) && focused !== state.opener && visible(focused)) return;
      focus(state.opener, true);
    }, state.addRequested ? 1200 : 0);
  }
  function buildState(root, kind) {
    var dialog = kind === 'print' ? root : root.querySelector('.qfp-cc-modal');
    if (!dialog) return;
    // A storefront app hides div:empty. Span stays present before text arrives,
    // which live regions need in order to announce their first update reliably.
    var live = doc.createElement('span');
    live.setAttribute('data-fms-popup-a11y-live', '');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('aria-atomic', 'true');
    live.style.cssText = 'position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);clip-path:inset(50%);white-space:nowrap;border:0;';
    dialog.appendChild(live);
    states.push({ root: root, kind: kind, dialog: dialog, live: live, stage: null,
      opener: null, lastInside: null, addRequested: false, addAttempted: false, message: '' });
  }
  function discover() {
    states = states.filter(function (state) { return state.root.isConnected; });
    var print = doc.querySelector('#fmscp-modal');
    var colors = doc.querySelector('.qfp-cc-overlay');
    if (print && !states.some(function (s) { return s.root === print; })) buildState(print, 'print');
    if (colors && !states.some(function (s) { return s.root === colors; })) buildState(colors, 'colors');
  }
  function syncPressed(state) {
    var selector = state.kind === 'print' ? '#fmscp-chips button' : '[data-qfp-cc="chips"] button[data-family]';
    var cls = state.kind === 'print' ? 'fmscp-active' : 'qfp-cc-chip--selected';
    all(state.root, selector).forEach(function (button) { set(button, 'aria-pressed', button.classList.contains(cls) ? 'true' : 'false'); });
  }
  function announce(state) {
    var message = '', isError = false;
    if (state.kind === 'colors') {
      var approval = qfp(state, 'approval-status'), spinner = qfp(state, 'spinner-msg');
      if (visible(approval)) {
        message = approval.textContent.trim();
        isError = approval.classList.contains('qfp-cc-status--error');
      } else if (visible(spinner) && spinner.classList.contains('qfp-cc-status--error')) {
        message = spinner.textContent.trim(); isError = true;
      }
    } else if (state.addAttempted) {
      var price = state.root.querySelector('#fmscp-price-tot'), add = state.root.querySelector('#fmscp-add');
      var priceText = price && price.textContent.trim();
      // Only the existing add-error destinations, never changing dollar totals,
      // range hints (already role=status), slider values, or normal copy.
      // A blocked/uncertain cart intentionally leaves Add disabled after failure;
      // only its existing Adding label identifies a still-pending request.
      if (add && /^Adding/i.test(add.textContent.trim())) return;
      if (visible(add) && /something went wrong/i.test(add.textContent)) {
        message = add.textContent.trim(); isError = true;
      } else if (visible(price) && priceText && !/^\$\s*[\d,.]/.test(priceText) && !/^Choose your width and yardage/.test(priceText)) {
        message = priceText; isError = true;
      }
    }
    if (isError) state.addRequested = false;
    if (message === state.message) return;
    state.message = message;
    state.live.textContent = message;
  }
  function sync() {
    queued = null;
    if (stopped) return;
    discover();
    states.forEach(syncPressed);
    var next = current(), previous = active;
    if (previous !== next) {
      active = next;
      if (previous) { previous.stage = null; previous.lastInside = null; restore(previous); }
      if (next) {
        cancelRestore();
        if (!next.opener && !next.root.contains(doc.activeElement) && enabled(doc.activeElement)) next.opener = doc.activeElement;
        next.stage = stage(next);
        next.message = ''; next.live.textContent = '';
        focus(initialFocus(next));
      }
    } else if (next) {
      var nextStage = stage(next);
      if (nextStage !== next.stage) {
        next.stage = nextStage;
        focus(initialFocus(next));
      } else if (next.lastInside && (!next.root.contains(next.lastInside) || !enabled(next.lastInside)) &&
          (doc.activeElement === doc.body || doc.activeElement === doc.documentElement || doc.activeElement === next.lastInside)) {
        // Chromium may silently drop focus to BODY when a focused button is
        // disabled/removed, with no focusin event. Only recover a known lost
        // in-popup target; do not steal deliberate focus elsewhere.
        focus(recoveredFocus(next));
      } else if (next.root.contains(doc.activeElement) && !visible(doc.activeElement)) {
        focus(initialFocus(next));
      }
    }
    if (next) announce(next);
  }
  function schedule() {
    if (!stopped && queued === null) queued = view.setTimeout(sync, 0);
  }
  function openTarget(node) {
    var control = node && node.closest && node.closest('#fmscp-open,[data-qfp-cc="open"]');
    if (!control) return null;
    return { control: control, kind: control.id === 'fmscp-open' ? 'print' : 'colors' };
  }
  function click(event) {
    var opening = openTarget(event.target);
    if (opening) {
      discover();
      var openingState = stateFor(opening.kind);
      if (openingState && !isOpen(openingState)) {
        openingState.opener = opening.control;
        openingState.addRequested = false; openingState.addAttempted = false;
      }
      cancelRestore();
    }
    var state = current();
    if (!state || !event.target || !state.root.contains(event.target)) return;
    var target = event.target.closest('button');
    if (target && enabled(target) && (target.id === 'fmscp-add' || target.getAttribute('data-qfp-cc') === 'approve')) {
      state.addRequested = true; state.addAttempted = true;
      // A second failed attempt deserves a new announcement even when the
      // server returns exactly the same text. Ignore the stale text while busy.
      state.message = ''; state.live.textContent = '';
    }
    if (event.target === state.root || (target && (target.id === 'fmscp-close' || target.id === 'fmscp-cancel' ||
        ['close', 'success-close'].indexOf(target.getAttribute('data-qfp-cc')) !== -1))) state.addRequested = false;
  }
  function keydown(event) {
    var state = current();
    if (!state || event.isComposing) { if (!state) cancelRestore(); return; }
    if (event.key === 'Escape') {
      var close = state.root.querySelector(state.kind === 'print' ? '#fmscp-close' : '[data-qfp-cc="close"]');
      if (!enabled(close)) return;
      event.preventDefault();
      event.stopImmediatePropagation(); // Existing color Escape must not also pop history.
      state.addRequested = false;
      close.click();
    } else if (event.key === 'Tab') {
      var list = tabbables(state), index = list.indexOf(doc.activeElement), target = null;
      if (!list.length) target = initialFocus(state);
      else if (event.shiftKey && index <= 0) target = list[list.length - 1];
      else if (!event.shiftKey && (index < 0 || index === list.length - 1)) target = list[0];
      if (target) { event.preventDefault(); focus(target); }
    }
  }
  function focusin(event) {
    var state = current();
    if (!state) {
      // A shopper or a newly opened drawer has deliberately taken focus.
      if (event.target !== doc.body && !states.some(function (s) { return s.root.contains(event.target); })) cancelRestore();
      return;
    }
    if (state.root.contains(event.target) && visible(event.target)) { state.lastInside = event.target; return; }
    if (redirecting) return;
    redirecting = true;
    focus(enabled(state.lastInside) ? state.lastInside : recoveredFocus(state));
    redirecting = false;
  }

  listen('click', click);
  listen('keydown', keydown);
  listen('focusin', focusin);
  listen('pointerdown', function () { if (!current()) cancelRestore(); });
  var observer = new view.MutationObserver(schedule);
  observer.observe(doc.body, { childList: true, subtree: true, characterData: true, attributes: true,
    attributeFilter: ['class', 'hidden', 'style', 'disabled', 'aria-hidden', 'inert', 'open'] });
  sync();

  // Test/teardown handle remains closure-local in browsers; no storefront globals.
  return { disconnect: function () {
    stopped = true; observer.disconnect(); cancelRestore();
    if (queued !== null) view.clearTimeout(queued);
    listenerRecords.forEach(function (record) { doc.removeEventListener(record[0], record[1], true); });
    states.forEach(function (state) { state.live.remove(); });
    doc.documentElement.removeAttribute('data-fms-popup-a11y-bound');
  } };
});
